<div class="spinner-container" *ngIf="!loaded">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card appearance="outlined" class="mat-elevation-z8" [ngClass]="{'invisible': !loaded, 'visible': loaded }">
    <div class="container">
        <div class="row">
            <mat-tab-group class="col" (selectedTabChange)="onTabChange($event)" animationDuration="0ms">
                <!-- <mat-tab *ngIf="showFirstTab">
                    <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                        <cqes-icon icon="done"></cqes-icon>
                        {{'historyTexts.documentsReceived' | translate}}
                    </ng-template>
                    <mat-card>
                        <cloud-business-signing-history class="col-12"
                            (isDataLoaded)="loadedData($event)"></cloud-business-signing-history>
                    </mat-card>
                </mat-tab> -->
                <!-- Signing history -->
                <!--  ПП - Да не се трие, предстои да се разработва допълнително
                <mat-tab *ngIf="showFirstTab">
                    <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                        <cqes-icon icon="done"></cqes-icon>
                        {{'historyTexts.documentsReceived' | translate}}
                    </ng-template>
                    <mat-card>
                        <cloud-business-signing-history class="col-12"
                            (isDataLoaded)="loadedData($event)"></cloud-business-signing-history>
                    </mat-card>
                </mat-tab> -->

                <!-- Sent history -->
                <mat-tab [disabled]="!hasIdentification">
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                        {{'historyTexts.documentsSent' | translate}}
                    </ng-template>
                    <mat-card *ngIf="selectedTabs[0]">
                        <cloud-business-requested-history class="col-12"></cloud-business-requested-history>
                    </mat-card>
                </mat-tab> 

                <!-- Identification history -->
                <mat-tab [disabled]="!hasIdentification">
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                        {{'businessTexts.mobileIdentification' | translate}}
                    </ng-template>
                    <mat-card *ngIf="selectedTabs[1]">
                        <cloud-business-identification class="col-12"></cloud-business-identification>
                    </mat-card>
                </mat-tab>
                <mat-tab [disabled]="!hasWebIdentification">
                    <!-- <mat-tab> -->
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                        {{'businessTexts.webIdentification' | translate}}
                    </ng-template>
                    <mat-card *ngIf="selectedTabs[2]">
                        <cloud-business-web-indentification></cloud-business-web-indentification>
                    </mat-card>
                </mat-tab>

                <!-- In copy -->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                        {{'businessTexts.inCopy' | translate}}
                    </ng-template>
                    <mat-card *ngIf="selectedTabs[3]">
                        <cloud-business-in-copy-history class="col-12"></cloud-business-in-copy-history>
                    </mat-card>
                </mat-tab>

                <!-- Identification history -->
                <!-- <mat-tab [disabled]="!hasIdentification">
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                        {{'businessTexts.identification' | translate}}
                    </ng-template>
                    <mat-card *ngIf="selectedTabs[4]">
                        <cloud-business-identification class="col-12"></cloud-business-identification>
                    </mat-card>
                </mat-tab> -->
            </mat-tab-group>
        </div>
    </div>
</mat-card>